import type { ReactNode } from "react";
import { t } from "@/lib/typography";
import type { PracticeLabResponse } from "@/types/practice-lab";

// Lab title, eyebrow, and meta, with the connection pill passed in.
export function LabHeader({
  lab,
  pill,
}: {
  lab: PracticeLabResponse;
  pill: ReactNode;
}) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="space-y-1">
        <p className={t.label}>Practice Lab · {lab.technology}</p>
        <h1 className={`${t.pageTitle} break-words`}>{lab.title}</h1>
      </div>
      {pill}
    </div>
  );
}
